module.exports = __webpack_public_path__ + "static/media/11.11c17a8c.png";